// extracted by css-extract-rspack-plugin
export default {"video":"gFlj3"};